/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions';
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGames.js.map